<template>
  <v-form ref="form" v-model="validForm">
    <h3>{{ $t('withdraws.withdraw_methods.types.bank') }}</h3>
    <p class="mb-2">{{ $t('withdraws.withdraw_methods.bank.form_description') }}</p>
    <v-row>
      <v-col cols="8">
        <v-autocomplete class="country"
                        :items="countries"
                        v-model="bankCountry"
                        item-text="text"
                        item-value="value3"
                        :label="$t('models.withdraw_bank_info.bank_country')"
                        :placeholder="$t('models.user.select_option')"
                        outlined
                        return-object
                        :rules="[$vRequired]"></v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-select :disabled="!bankCountry"
                  class="currency"
                  :items="countryCurrencies"
                  v-model="bankCurrency"
                  item-text="name"
                  item-value="code"
                  :label="$t('models.withdraw_bank_info.bank_currency')"
                  outlined
                  :placeholder="$t('models.user.select_option')"
                  :rules="[$vRequired]"></v-select>
      </v-col>
    </v-row>
    <span v-if="bankCountry">
      <v-text-field outlined
                    :label="$t('models.withdraw_bank_info.bank_name')"
                    type="text"
                    v-model="bankName"
                    :rules="[$vRequired]"></v-text-field>
      <v-text-field outlined
                    :label="accountLabel"
                    type="text"
                    v-model="bankAccount"
                    :rules="[$vRequired]"></v-text-field>
      <v-text-field v-if="isFromUSA"
                    outlined
                    :label="$t('models.withdraw_bank_info.routing_number')"
                    type="text"
                    v-model="bankRoutingNumber"></v-text-field>
      <v-text-field v-if="isFromCA"
                    outlined
                    :label="$t('models.withdraw_bank_info.transit_number')"
                    type="text"
                    v-model="swiftAccount"></v-text-field>
      <v-text-field outlined v-if="isFromCA"
                    :label="$t('models.withdraw_bank_info.institution_code')"
                    type="text"
                    v-model="bankRoutingNumber"
                    :rules="[$vRequired]"></v-text-field>
      <v-text-field outlined v-else
                    :label="$t('models.withdraw_bank_info.swift_number')"
                    type="text"
                    v-model="swiftAccount"
                    :rules="[$vRequired]"></v-text-field>
    </span>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import validatable from '@/components/mixins/validatable'

export default {
  name: 'BankMethodForm',
  mixins: [validatable('form')],
  props: {
    method: {
      type: Object,
      default: null
    },
    dark: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      validForm: false,
      bankName: null,
      bankCurrency: null,
      bankCountry: null,
      bankAccount: null,
      swiftAccount: null,
      bankRoutingNumber: null
    }
  },
  computed: {
    ...mapState('withdraws', ['withdrawData']),
    countries () {
      return this.$t('countries_v2')
    },
    countryCurrencies () {
      return this.bankCountry ? this.bankCountry.currencies : []
    },
    liveCountry () {
      return this.countries.find(c => c.value === this.withdrawData.country)
    },
    isFromUSA () {
      return this.bankCountry && this.bankCountry.value === 'US'
    },
    isFromCA () {
      return this.bankCountry && this.bankCountry.value === 'CA'
    },
    methodAttrs () {
      return {
        type: 'bank',
        accountId: this.bankAccount,
        withdrawMethodPath: '',
        withdrawMethodApproved: true,
        bankInfo: {
          bankName: this.bankName,
          bankCountry: this.bankCountry ? this.bankCountry.value : null,
          bankCurrency: this.bankCurrency,
          bankAccount: this.bankAccount,
          bankRoutingNumber: this.bankRoutingNumber || null,
          swiftAccount: this.swiftAccount
        }
      }
    },
    accountLabel () {
      return this.isEurope ? this.$t('models.withdraw_bank_info.iban_number') : this.$t('models.withdraw_bank_info.bank_account')
    }
  },
  watch: {
    methodAttrs () {
      this.$emit('methodAttrs', this.methodAttrs)
    },
    validForm () {
      this.$emit('validForm', this.validForm)
    }
  },

  mounted () {
    if (!this.method) {
      return
    }
    this.bankName = this.method.info.bankName
    this.bankCountry = this.countries.find(c => c.value === this.method.info.bankCountry)
    this.bankCurrency = this.bankCountry.currencies.find(c => c.code === this.method.info.bankCurrency)
    if (this.bankCurrency) this.bankCurrency = this.bankCurrency.code
    this.bankAccount = this.method.info.bankAccount
    this.bankRoutingNumber = this.method.info.bankRoutingNumber
    this.swiftAccount = this.method.info.swiftAccount
  }
}
</script>
